module.exports = __webpack_public_path__ + "static/media/medalCorrect.fc02bb86.png";